import React from 'react'
import { ReflectionFullInfoQueryResult } from '@graphql/queries/__generated__/reflection.generated'
import { ProductVariantFullInfoQueryResult } from '@graphql/queries/__generated__/product-variant.generated'
import { AddedProductVariantFragment } from '@graphql/fragments/__generated__/AddedProductVariant.generated'
import { SupplyLinesJson } from '../types'
import { UserFragment } from '@graphql/fragments/__generated__/User.generated'

function noop() {}

export interface PriceRange {
  currency: string
  discount: { min: number; max: number }
  undiscount: { min: number; max: number }
}

export interface IProductContext {
  selectedVariant: ProductVariantFullInfoQueryResult['data']['productVariant'] | null

  onChangeSelectedVariant(attrs): Promise<void>

  reflection: ReflectionFullInfoQueryResult['data']['reflectionDetails']['reflection']
  formValues: {
    quantity: number
    selectedAttrs: {
      [key: string]: string
    }
  }
  formMethods: {
    onChangeQuantity: any
    setSelectedAttrs: any
  }
  // pickerDataJson: any
  // selectedValues: {}
  loading: boolean
  me: UserFragment | null
  images: {
    id: string
    alt: string
    url: string
    thumbnail: string
    width: number
    height: number
  }[]
  attributes: {
    name: string
    values: string[]
  }[]
  lastAddedVariantInfo: {
    variant: AddedProductVariantFragment
    quantity: number
    cartLine: {
      id: string
      pk: number
    }
    product: {
      id: string
      pk: number
    }
    supplyLinesJson?: SupplyLinesJson
  }

  matchVariantFromSelection: any
  onAddToBag: any
  onAddToBagFullKit: any
  onCustomizeKit?: any
  isModal?: boolean

  setLastAddedVariantInfo(v): void

  // Wholesale mode: the wholesale variants and prices, and the wholesale cart, where a variant has one line whose
  // quantity the form sets ("Update", "Added: N pcs", "Remove").
  isWholesale: boolean
  // Unit price of the form: the selected variant's, or the product's range before a variant is picked; retail or
  // wholesale. Null for a product without wholesale variants in wholesale mode.
  priceRange: PriceRange | null
  // Price of the saved default kit of a customizable kit, retail or wholesale.
  defaultKitPrice: { currency: string; gross: number } | null
  maxQuantity: number
  // Wholesale mode: the selected variant's quantity in the wholesale cart.
  cartQuantity: number
  removing: boolean

  onRemoveFromCart(): void

  onDownloadFiles(url: string): void
  setIsOpenProductDialog?({}: { pk: number; slug: string }): void
}

const ProductContext = React.createContext<IProductContext>({
  selectedVariant: null,
  reflection: null,
  formValues: {
    quantity: 1,
    selectedAttrs: null,
  },
  formMethods: {
    onChangeQuantity: (qty: number) => {},
    setSelectedAttrs: (attrs: any) => {},
  },
  loading: false,
  me: null,
  attributes: [],
  images: [],
  lastAddedVariantInfo: null,
  isModal: false,

  matchVariantFromSelection: noop,
  onAddToBag: noop,
  onAddToBagFullKit: noop,
  onCustomizeKit: noop,

  setLastAddedVariantInfo: noop,

  isWholesale: false,
  priceRange: null,
  defaultKitPrice: null,
  maxQuantity: 1,
  cartQuantity: 0,
  removing: false,
  onRemoveFromCart: noop,
  onDownloadFiles: url => {},
  onChangeSelectedVariant: async attrs => {},
  setIsOpenProductDialog: values => null,
})
export default ProductContext
